import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "../SectionHeading";
import { PROCESS } from "../../data/site";

export const Process = () => {
  return (
    <section data-testid="process-section" className="relative py-24 md:py-32 bg-navy">
      <div className="container-x">
        <SectionHeading
          overline="How We Work"
          title="A disciplined engagement process"
          subtitle="Five clear phases — from understanding your business to running your systems at scale."
        />

        <div className="mt-16 relative">
          {/* connecting line */}
          <div className="hidden lg:block absolute top-9 left-0 right-0 h-px bg-white/10">
            <motion.div
              initial={{ scaleX: 0 }}
              whileInView={{ scaleX: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.4, ease: "easeInOut" }}
              style={{ transformOrigin: "left" }}
              className="h-full bg-gradient-to-r from-brand-orange to-brand-orange/30"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-4">
            {PROCESS.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.18 }}
                  className="relative"
                >
                  <div className="w-18 h-18 relative mx-auto lg:mx-0">
                    <div className="w-[72px] h-[72px] rounded-2xl bg-navy-deep border border-brand-orange/40 grid place-items-center relative z-10 shadow-[0_0_30px_rgba(242,101,34,0.15)]">
                      <Icon size={28} className="text-brand-orange" />
                    </div>
                  </div>
                  <span className="block font-mono text-xs text-brand-orange mt-5 tracking-widest">{p.n}</span>
                  <h3 className="font-head text-xl font-semibold text-white mt-2">{p.title}</h3>
                  <p className="text-slate-400 text-sm mt-2 leading-relaxed pr-2">{p.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
